'use client';

import React, { useState, useEffect } from 'react';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import type { PagesQuery } from '../../graphql/generated/schema';
import styles from './styles.module.scss';
import { constructClassName } from '../../utils/constructClassName';
import useIntersect from '../../hooks/useIntersect';

export const AnimatedTextBlock: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'AnimatedTextBlock'>> = ({
  text,
  value,
  hasDarkBackground,
}) => {
  const [animatedValue, setAnimatedValue] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [setNote, entry] = useIntersect({
    threshold: 0.5,
  });
  const delay = 100;

  useEffect(() => {
    if (entry?.isIntersecting) {
      setTimeout(() => {
        setLoaded(true);
      }, delay);
    }
  }, [entry?.isIntersecting, delay]);

  useEffect(() => {
    const animateValue = (val: number) => {
      let start = 0;
      const end = val;

      if (!loaded) {
        return;
      }

      setTimeout(() => {
        const step = () => {
          if (start < end) {
            start += 1;
            setAnimatedValue(start);
            setTimeout(step, 10);
          }
        };

        step();
      }, 0);
    };

    animateValue(value || 0);
  }, [loaded, value]);

  return (
    <div className={constructClassName([
      styles.container,
      hasDarkBackground && styles.lightText,
    ])}
    >
      <p className={styles.text}>{text}</p>
      <p
        className={styles.value}
        // TODO: strongly type this ref
        ref={setNote as unknown as React.RefObject<HTMLParagraphElement>}
      >
        {animatedValue}
        %
      </p>
    </div>
  );
};
